package com.ustadmobile.door.sqljsjdbc

import com.ustadmobile.door.jdbc.ResultSet

data class UpdateResult(val numRowsChanged: Int, val autoGeneratedKey: ResultSet?)